import { ActionTypes } from "../type";

const initialState ={
    department:null
}

export const departmentReducer = (state=initialState,action)=>{
    switch (action.type){
        case ActionTypes.DEPARTMENT:
            return {...state,department:action.payload}
        default:
            return state;
    }
}